// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminConfirmationController from "./admin_confirmation_controller"
application.register("admin-confirmation", AdminConfirmationController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import DeleteConfirmationController from "./delete_confirmation_controller"
application.register("delete-confirmation", DeleteConfirmationController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)


import FilePreviewController from "./file_preview_controller"
application.register("file-preview", FilePreviewController)

import FilePondController from "./filepond_controller"
application.register("filepond", FilePondController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InlineEditorController from "./inline_editor_controller"
application.register("inline-editor", InlineEditorController)

import InviteFormController from "./invite_form_controller"
application.register("invite-form", InviteFormController)

import LineItemFormController from "./line_item_form_controller"
application.register("line-item-form", LineItemFormController)

import LinkController from "./link_controller"
application.register("link", LinkController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import RichTextController from "./rich_text_controller"
application.register("rich-text", RichTextController)



import SimpleSidebarController from "./simple_sidebar_controller"
application.register("simple-sidebar", SimpleSidebarController)

import SimpleFileUploadController from "./simple_file_upload_controller"
application.register("simple-file-upload", SimpleFileUploadController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import CcEmailsController from "./cc_emails_controller"
application.register("cc-emails", CcEmailsController)
